import { FormatMessageType } from '@hooks/useValidation';
import { EMAIL, POSITIVE, REQUIRED, REQUIRED_FIELD } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { MessageRequestMediaEnum } from '@/types/chat/chat.types';

import { polygonSchema } from './polygon.schema';

const nfzEntryParametersSchema = (formatMessage: FormatMessageType) =>
  Yup.object({
    enabled: Yup.boolean(),
    levels: Yup.array().when('enabled', {
      is: true,
      then: (schema) => schema.min(1, formatMessage({ id: REQUIRED })),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

const nfzExitParametersSchema = (formatMessage: FormatMessageType) =>
  Yup.object({
    enabled: Yup.boolean(),
    levels: Yup.array().when('enabled', {
      is: true,
      then: (schema) => schema.min(1, formatMessage({ id: REQUIRED })),
      otherwise: (schema) => schema.notRequired(),
    }),
    delay: Yup.number()
      .required(formatMessage({ id: REQUIRED }))
      .min(0, formatMessage({ id: POSITIVE })),
  });

const droneLostParametersSchema = () =>
  Yup.object({
    enabled: Yup.boolean(),
  });

const messagingParametersSchema = (formatMessage: FormatMessageType) =>
  Yup.object({
    nfzEntry: nfzEntryParametersSchema(formatMessage),
    nfzExit: nfzExitParametersSchema(formatMessage),
    droneLost: droneLostParametersSchema(),
  });

export function platformSchemaValidation(formatMessage: FormatMessageType) {
  return Yup.object({
    name: Yup.string().required(
      formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'components.platforms.general.name' }) }),
    ),
    heightOffset: Yup.number().required(
      formatMessage(
        { id: REQUIRED_FIELD },
        { field: formatMessage({ id: 'components.platforms.general.heightOffset' }) },
      ),
    ),
    messagingParameters: messagingParametersSchema(formatMessage),
    polygon: polygonSchema(formatMessage),
    contacts: Yup.array().of(
      Yup.object({
        name: Yup.string().required(
          formatMessage(
            { id: REQUIRED_FIELD },
            { field: formatMessage({ id: 'components.platforms.diffusionLists.name' }) },
          ),
        ),
        contact: Yup.string().when('media', {
          is: MessageRequestMediaEnum.EMAIL,
          then: (schema) =>
            schema
              .required(
                formatMessage(
                  { id: REQUIRED_FIELD },
                  {
                    field: formatMessage({
                      id: 'components.platforms.diffusionLists.email',
                    }),
                  },
                ),
              )
              .email(formatMessage({ id: EMAIL })),
          otherwise: (schema) =>
            schema.required(
              formatMessage(
                { id: REQUIRED_FIELD },
                {
                  field: formatMessage({
                    id: 'components.platforms.diffusionLists.phone',
                  }),
                },
              ),
            ),
        }),
      }),
    ),
  });
}
